import { render, staticRenderFns } from "./ZendeskWidget.vue?vue&type=template&id=1afab3ec&scoped=true&lang=pug&"
import script from "./ZendeskWidget.vue?vue&type=script&lang=js&"
export * from "./ZendeskWidget.vue?vue&type=script&lang=js&"
import style0 from "./ZendeskWidget.vue?vue&type=style&index=0&id=1afab3ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afab3ec",
  null
  
)

export default component.exports